import { render, staticRenderFns } from "./ReceiveToast.vue?vue&type=template&id=42042c44"
import script from "./ReceiveToast.vue?vue&type=script&lang=js"
export * from "./ReceiveToast.vue?vue&type=script&lang=js"
import style0 from "./ReceiveToast.vue?vue&type=style&index=0&id=42042c44&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports